
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"124","height":"114","viewBox":"0 0 124 114","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_401_17308)"}},[_c('path',{attrs:{"d":"M76.8274 3.30382L76.8273 3.30371C75.5675 2.15839 73.8399 1.5004 72.0208 1.5L76.8274 3.30382ZM76.8274 3.30382L105.557 29.4146L105.557 29.4147M76.8274 3.30382L105.557 29.4147M105.557 29.4147C106.814 30.5568 107.5 32.0843 107.5 33.6545C107.5 33.6545 107.5 33.6546 107.5 33.6547V99.1111C107.5 102.55 105.998 105.869 103.288 108.332C100.574 110.799 96.8748 112.198 93 112.198H31C27.1252 112.198 23.426 110.799 20.7124 108.332C18.002 105.869 16.5 102.55 16.5 99.1111V14.5873C16.5 11.1488 18.002 7.82945 20.7124 5.3661C23.426 2.89986 27.1252 1.5 31 1.5H32M105.557 29.4147L32 1.5M32 1.5H72.0206H32ZM74.2976 10.3255L72.625 8.80531V11.0655V25.1528C72.625 27.3186 73.5725 29.3739 75.2223 30.8734C76.869 32.37 79.0836 33.1964 81.375 33.1964H96.875H99.4621L97.5476 31.4564L74.2976 10.3255Z","fill":"white","stroke":"#EAECF0","stroke-width":"2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_401_17308"}},[_c('rect',{attrs:{"width":"124","height":"112.698","fill":"white","transform":"translate(0 0.5)"}})])])])
          )
        }
      }
    